import 'leaflet/dist/leaflet.css';
import { useLocation, useNavigate } from 'react-router-dom';
import './map.css';
import L from 'leaflet';
import { useContext, useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, Popup, useMap } from 'react-leaflet';
import { cartContext } from '../../App';
import Cookies from 'js-cookie';
import HeaderOther from '../ui/header-other';

// Fix for default marker icons
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function calculateDistance(lat1, lon1, lat2, lon2) {
    const R = 6371; // Earth's radius in kilometers
    const toRadians = (degree) => (degree * Math.PI) / 180;

    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return R * c; // Distance in kilometers
}

const LocationPicker = () => {

    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    const { addPositionCoords, userId } = useContext(cartContext);
    const navigate = useNavigate();
    const location = useLocation();
    const coords = location.state?.positionCoords ? (location.state?.positionCoords) : null
    const [position, setPosition] = useState(coords ? typeof(coords) === 'string' ? (coords.split(",").map(Number)) : coords: [23.9925, 85.3637]); // Default position
    const phoneNumber = location.state?.phone
    const address = location.state?.address 
    const userName = location.state?.name
    // address variables
    const [houseNo, setHouseNo] = useState('');
    const [apartment, setApartment] = useState(address);
    const [landmark, setLandmark] = useState('');
    const [name, setName] = useState(userName);
    const [phone, setPhone] = useState(phoneNumber && Number(String(location.state?.phone.split(':')[1])));
    const [isCurrentLocClicked, setIsCurrentLocClicked] = useState(false);

    //save address
    function handleSave(e) {
        e.preventDefault();

        if (!isCurrentLocClicked) {
            const result = window.confirm("Allow location access for faster delivery");
            if (result) {
                handleClick();
                return;
            // call navigator.geolocation.getCurrentPosition() here if needed
            } else {
                alert("Okay! 📍 Without location, delivery might take a bit longer.");
            }
        }
        const radius = calculateDistance(23.9925, 85.3637, position[0], position[1]);
        console.log('radius:', radius)
        if(phone && phone.toString().length !== 10 ) {
            alert('Phone Number is not Valid !')  
        // } else if (radius >= Number(extraData.data.radius)) {
        //     Cookies.remove('address', {path:'/'});
        //     Cookies.set('address', 'unserviceable', { expires: 1, path: '/' });
        //     navigate(-1);
        } else if (apartment && name && phone) {
            const add = name + ", " + houseNo + " " + apartment  + " " + landmark + ", Phone: " + phone;
            addPositionCoords(position);
            Cookies.remove('address', {path:'/'});
            Cookies.remove('positionCoords', {path:'/'});
            Cookies.set('address', add, { expires: 1, path: '/' });
            Cookies.set('positionCoords', position, { expires: 1, path: '/' })

            if (userId) {

                const addressPayload = {
                    name,
                    addressLine1: houseNo,
                    addressLine2: apartment + (landmark ? `, Landmark: ${landmark}` : ""),
                    area: apartment,
                    phone,
                };
                const dataToSend = {
                    userId: userId,
                    address: addressPayload,
                    type: location.state?.type || 'home',
                    positionCoords: position,
                };
                fetch(`${BACKEND_URL}/add-user-address`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${AUTH_TOKEN}`,  // Send token in header 
                        'content-type':'application/json',
                    },
                    body:JSON.stringify(dataToSend)
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.success) {
                            alert('Address saved successfully!');
                            navigate(-1);
                        } else {
                            alert('Failed to save address. Please try again.');
                        }
                })
            } else {
                console.log('User not logged in, address saved in cookies only.');
                alert('Please log in to save it permanently.');
                navigate('/login');
            }
        } else {
            alert('Area, Name and Phone are required!');
        }
    }

    const LocationMarker = () => {

        const map = useMap();

        useEffect(() => {
            map.setView(position);
        })

        useMapEvents({
            click(e) {
                setPosition([e.latlng.lat, e.latlng.lng]);
                console.log(e.latlng.lat, e.latlng.lng)
            },
        });

        return position ? (
            <Marker position={position}>
                <Popup>Your order will be delivered here.</Popup>
            </Marker>
        ) : null;
    };

    function handleClick() {
        setIsCurrentLocClicked(true);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const { latitude, longitude } = position.coords;
                setPosition([latitude, longitude]);
            },
                (error) => {
                    console.log("error getting the location!", error);
            });
        } else {
            alert('Geo Location not supported by the brower!');
        }
        
    }

    return (
        <>
            <HeaderOther title='Add Address' description='Delivery location'/>
            <div className='map-container'>
                <div style={{width:'100%'}}>
                    <MapContainer
                        center={position}
                        zoom={16}
                        style={{ height: "400px", width: "97.5%" , marginLeft: "5px"}}
                        
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution="&copy; <a href='http://osm.org/copyright'>OpenStreetMap</a> contributors"
                        />
                        <LocationMarker />
                    </MapContainer>
                    <div className='location-btn-container'>
                        <div className='location-btn' onClick={handleClick} ><img src='/locate-me2.png' style={{height: '15px', width: '15px', position: 'relative', top: '3px', right: '2px'}} /> LOCATE ME</div>
                    </div>
                </div>
                <div className='address-form'>
                    <p className='address-names'>NAME</p>
                    <input
                            className='input-names'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                    ></input>
                    <p className='address-names'>HOUSE/FLAT/FLOOR NO. <i>(optional)</i></p>
                    <input
                        className='input-names'
                        value={houseNo}
                        onChange={(e) => setHouseNo(e.target.value)}
                    ></input>
                    <p className='address-names'>APARTMENT/ROAD/AREA</p>
                    <input
                        className='input-names'
                        value={apartment}
                        onChange={(e) => setApartment(e.target.value)}
                    ></input>
                    <p className='address-names'>DIRECTION TO REACH (LANDMARK ) <i>(optional)</i></p>
                    <input
                        className='input-names'
                        value={landmark}
                        onChange={(e) => setLandmark(e.target.value)}
                    ></input>
                    <p className='address-names'>PHONE NO.</p>
                    <input
                        type='number'
                        className='input-names'
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    ></input>
                    <div className='cart-bottom-btns' onClick={handleSave} style={{marginTop:'10px'}}>SAVE</div>
                </div>
            </div>
        </>
    );
};

export default LocationPicker;



